export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5611.c2dab460.jpg";